module.exports = __webpack_public_path__ + "f32eb678cf31370ca15fd2f4c422a211.svg";